import { useEffect, useState } from 'react'
import { CustomerApplication } from '../../../utilities/CustomerData'

import infoIcon from '../../../assets/ApplicationIcons/infoIcon.png'
import estimateRefundIcon from '../../../assets/ApplicationIcons/estimateRefundIcon.png'

export function ApplicationStep6({ _customerApplication, estimateRefund, step, setStep, handleApplicationStep6, handleSetApplicationStep6 }) {
  const customerApplication = new CustomerApplication(_customerApplication)

  const [childUnder18, setChildUnder18] = useState(customerApplication.childUnder18)
  const [taxCreditFamilyJanuary, setTaxCreditFamilyJanuary] = useState(customerApplication.taxCreditFamilyJanuary)
  const [taxCreditFamilyApril, setTaxCreditFamilyApril] = useState(customerApplication.taxCreditFamilyApril)
  const [showImportant, setShowImportant] = useState(false)
  const [childStep, setChildStep] = useState(0)
  const [claimingDependents, setClaimingDependents] = useState('')

  useEffect(() => {
    handleSetApplicationStep6(taxCreditFamilyJanuary, taxCreditFamilyApril)
  }, [taxCreditFamilyJanuary, taxCreditFamilyApril])

  const handleBackButton = () => {
    if(childUnder18 === 'Yes') {
      if(childStep === 0)
        setStep(step-1)
      else
        setChildStep(childStep-1)
    } else {
      if(customerApplication.taxCreditGovApril.length < 10)
        setStep(step-1)
      else if(customerApplication.taxCreditGovJanuary.length < 10)
        setStep(step-2)
      else
        setStep(step-3) 
    }
  }

  const handleDependentCheck = () => {
    if(claimingDependents === 'No')
      handleApplicationStep6('No', 0, 0)
    else
      handleApplicationStep6(childUnder18, taxCreditFamilyJanuary, taxCreditFamilyApril)
  }

  return (
    <div className='w-11/12 h-full flex flex-col items-center lg:justify-center mt-8 mb-10'>
      {estimateRefund > 0 && (
        <div className='h-fit p-6 rounded-lg shadow-lg bg-gray-50 flex items-center gap-4 mb-4'>
          <div className='w-12 h-12 flex items-center justify-center rounded-full bg-secondaryColor object-contain'>
            <img 
              className='w-8 h-8' 
              src={estimateRefundIcon} 
              alt='Estimate Icon' 
            />
          </div>
          <div className='flex flex-col'>
            <p className='text-gray-600 text-sm font-medium'>Current Estimate</p>
            <p className='text-xl font-bold text-gray-900'>
              ${Number(estimateRefund).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </p>
          </div>
        </div>
      )}
      <div className='w-full gap-4'>
        <div className='flex flex-col items-center'>
          <p>Did you take care of a child under the age of 18 in 2021?</p>
          <div className='flex flex-row items-center gap-4 mt-2 mb-10'>
            <button onClick={() => setChildUnder18('Yes')} className={`w-24 py-2 ${childUnder18 === 'Yes' ? 'bg-primaryDarkColor text-white' : 'hover:bg-primaryColor hover:text-white border-[1px] text-black'} rounded-md`}>
              Yes
            </button>
            <button onClick={() => { setChildUnder18('No'); setTaxCreditFamilyJanuary(0); setTaxCreditFamilyApril(0) }} className={`w-24 py-2 ${childUnder18 === 'No' ? 'bg-primaryDarkColor text-white' : 'hover:bg-primaryColor hover:text-white border-[1px] text-black'} rounded-md`}>
              No
            </button>
          </div>
        </div>
      </div>
      {childUnder18 === 'Yes' && (
        childStep === 0 ? (
          <div className='flex flex-col items-center mb-10'>
            <p className='font-bold text-3xl mb-5 text-setcb'>Family Leave Tax Credit</p>
            <p className='text-setcg font-bold text-2xl'>$200 Daily Maximum Credit</p>
            <p>Please select the number of days you were unable to work because your child was sick, told to quarantine, or your child's school or daycare closed due to COVID-19. Please note, you are not required to submit exact dates.</p>
            <p className='mt-4'>January 1, 2021 through March 31, 2021 <span className='font-bold'>(50 Days Max)</span></p>
            <div className='w-full flex flex-col items-center mt-4'>
              <div className='mb-2'>
                <span className='bg-white text-gray-700 border border-gray-300 px-2 py-1 rounded-lg shadow-sm'>
                  {taxCreditFamilyJanuary} days
                </span>
              </div>
              <div className='w-full relative flex items-center gap-4'>
                <span className='text-gray-700 text-nowrap'>0 days</span>
                <input
                  type='range'
                  id='dateSlider'
                  min='0'
                  max='50'
                  step='1'
                  value={taxCreditFamilyJanuary}
                  onChange={(e) => setTaxCreditFamilyJanuary(Number(e.target.value))}
                  className='w-full h-2 bg-gray-300 rounded-lg outline-none appearance-none slider-thumb'
                  style={{
                    background: `linear-gradient(to right, #74be43 ${((taxCreditFamilyJanuary / 50) * 100)}%, #ddd ${((taxCreditFamilyJanuary / 50) * 100)}%)`,
                  }}
                />
                <span className='text-gray-700 text-nowrap'>50 days</span>
              </div>
            </div>
            <p className='mt-10'>April 1, 2021 through September 30, 2021 <span className='font-bold'>(60 Days Max)</span></p>
            <div className='w-full flex flex-col items-center mt-4'>
              <div className='mb-2'>
                <span className='bg-white text-gray-700 border border-gray-300 px-2 py-1 rounded-lg shadow-sm'>
                  {taxCreditFamilyApril} days
                </span>
              </div>
              <div className='w-full relative flex items-center gap-4 text-nowrap'>
                <span className='text-gray-700'>0 days</span>
                <input
                  type='range'
                  id='dateSlider'
                  min='0'
                  max='60'
                  step='1'
                  value={taxCreditFamilyApril}
                  onChange={(e) => setTaxCreditFamilyApril(Number(e.target.value))}
                  className='w-full h-2 bg-gray-300 rounded-lg outline-none appearance-none slider-thumb'
                  style={{
                    background: `linear-gradient(to right, #74be43 ${((taxCreditFamilyApril / 60) * 100)}%, #ddd ${((taxCreditFamilyApril / 60) * 100)}%)`,
                  }}
                />
                <span className='text-gray-700 text-nowrap'>60 days</span>
              </div>
            </div>
          </div>
        ) : (
          <div className='flex flex-col items-center mb-10 gap-4'>
            <p>Your response to the previous question regarding days you were unable to work because of coronavirus-related care you provided to a <strong>SON</strong> or <strong>DAUGHTER</strong> indicated that you did, in fact, claim one or more such days. Please note, the IRS is actively evaluating these claims and only granting this portion of the credit to filers who have a qualifying dependent child on record for tax year 2021.</p>
            <label className="flex items-center space-x-2">
              <input 
                type="checkbox" 
                name="claimedDependent" 
                checked={claimingDependents === 'Yes'}
                onChange={() => setClaimingDependents('Yes')}
                className="w-5 h-5 text-primaryColor focus:ring-primaryColor"
              />
              <span>Yes, I claimed my son or daughter as a dependent on my originally filed 2021 Form 1040.</span>
            </label>
            <label className="flex items-center space-x-2">
              <input 
                type="checkbox" 
                name="claimedDependent" 
                checked={claimingDependents === 'No'}
                onChange={() => setClaimingDependents('No')}
                className="w-5 h-5 text-primaryColor focus:ring-primaryColor"
              />
              <span>No, I did not claim my son or daughter as a dependent on my originally filed 2021 Form 1040. Please process my credit without those days included.</span>
            </label>
          </div>
        )
      )}
      <div className='w-full bg-[#0973ba] p-4 rounded-lg mt-4 text-white'>
        <div onClick={() => setShowImportant(!showImportant)} className='cursor-pointer flex flex-row items-center gap-2'>
          <img className='w-6' src={infoIcon} alt='Info Icon' />
          <p className='font-bold'>Important</p>
          <p className='ml-auto text-setcg'>{showImportant ? 'Collapse' : 'Expand'}</p>
        </div>
        {showImportant && (
          <div className='mt-4'>
            <p className='mb-4'>Days claimed to personal or other's care can't be counted again for child care.</p>
            <p>Days claimed for unemployment cannot be selected again for childcare days.</p>
          </div>
        )}
      </div>
      <div className='flex flex-row items-center gap-4'>
        <button
          onClick={() => handleBackButton()}
          className='flex flex-row items-center gap-2 px-8 py-2 text-white rounded-md transition-colors duration-200 mb-4 mt-10 bg-gray-400 hover:bg-gray-500'
        >
          Back
        </button>
        <button
          onClick={() => { childUnder18 === 'Yes' ? ( childStep === 0 ? setChildStep(childStep+1) : handleDependentCheck() ) : handleApplicationStep6(childUnder18, taxCreditFamilyJanuary, taxCreditFamilyApril) }}
          className='flex flex-row items-center gap-2 px-8 py-2 text-white rounded-md mb-4 mt-10 bg-primaryColor hover:bg-primaryDarkColor transition duration-200'
        >
          Next
        </button>
      </div>
    </div>
  )
}